import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      display: 'flex',
    },
  }),
);

export default useStyles;
